import type { PurchaseOrder } from "../redistribution/models/PurchaseOrder.ts";
import { clonePurchaseOrders } from "./objectCloning.ts";

/**
 * Resolves the pre-redistribution PO snapshot used by Before & After.
 *
 * Prefer the clone captured when the job was submitted. If that snapshot is
 * missing (page reload of a completed queue item, older clients), reconstruct
 * before-quantities from each SKU's server-computed `difference`.
 */
export function resolveOriginalPurchaseOrders(
  updatedPurchaseOrders: PurchaseOrder[],
  storedOriginals?: PurchaseOrder[]
): PurchaseOrder[] {
  if (storedOriginals && storedOriginals.length > 0) {
    return clonePurchaseOrders(storedOriginals);
  }

  return updatedPurchaseOrders.map((purchaseOrder) => ({
    ...purchaseOrder,
    skus: purchaseOrder.skus.map((sku) => ({
      ...sku,
      lineItemQuantity: sku.lineItemQuantity - (sku.difference ?? 0),
    })),
  }));
}
